import { c as _c } from "react/compiler-runtime";
import Header from '@sbt-web/header';
import useUser from '@/client/contexts/UserContext';
import styles from './index.module.scss';
export const HeaderWrapper = () => {
  const $ = _c(6);
  const {
    user
  } = useUser();
  const t0 = user?.id ?? "";
  const t1 = user?.name ?? "";
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      id: t0,
      name: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      hadesBase: process.env.NEXT_PUBLIC_HADES_BASE_URL,
      baseURL: process.env.NEXT_PUBLIC_ENV_BASE_URL,
      assetsBase: process.env.NEXT_PUBLIC_ASSETS_BASE_URL,
      reservedArea: process.env.NEXT_PUBLIC_AREARISERVATA_BASE_URL,
      phpBase: process.env.NEXT_PUBLIC_PHP_BASE_URL,
      shopBase: process.env.NEXT_PUBLIC_IMPRESAPIU_BASE_URL
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className={styles.header_wrapper}><Header user={t2} urlPrefixes={t3} /></div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};